export default __webpack_public_path__ + "static/media/carousel-img-1.4322c305.png";